/* eslint-disable default-param-last */
import { combineReducers } from 'redux'
import storedDataReducer from './storedData'

const FAQ_INITIAL_STATE = {
  currentFAQItem: null,
}

const faqReducer = (state = FAQ_INITIAL_STATE, action) => {
  switch (action.type) {
    case 'FAQ_ITEM_TAPPED':
      return { ...state, currentFAQItem: action.payload }
    default:
      return state
  }
}

const rootReducer = combineReducers({
  faq: faqReducer,
  storedData: storedDataReducer,
})

export default rootReducer
